import styled from 'styled-components'

export type InfoVariant = 'neutral' | 'info'

const variantStyles = {
  neutral: `
    background: #f6f6f6;
    border: 1px solid #dddddd;
    color: #272727;
  `,
  info: `
    background: #f4fbff;
    border: 1px solid #8bc4e8;
    color: #2d4b62;
  `
}

export const CardContainer = styled.div<{ variant: InfoVariant }>`
  padding: 16px 20px;
  width: 100%;
  font-family: var(--font-barlow);
  ${({ variant }) => variantStyles[variant]}
`

export const Eyebrow = styled.span`
  display: block;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.3px;
  line-height: 16px;
  margin-bottom: 6px;
  text-transform: uppercase;
`

export const Title = styled.h3`
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  line-height: 30px;
  display: inline-flex;
  align-items: center;

  i {
    margin-right: 8px;
    font-size: 14px;
  }

  /* Allow consumers to size title through root data attributes. */
  [data-title='small'] &,
  [data-title-size='small'] & {
    font-size: 16px;
    line-height: normal;
  }

  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 28px;

    [data-title='small'] &,
    [data-title-size='small'] & {
      margin-top: 8px;
      font-size: 16px;
      line-height: 24px;
    }
  }
`

export const Description = styled.p`
  margin: 10px 0 0;
  font-size: 16px;
  line-height: 24px;
  color: #000000A6;
  margin-top: 8px;
  
  /* Allow consumers to size description through root data attributes. */
  [data-title='small'] &,
  [data-title-size='small'] & {
    margin-top: 16px;
    font-size: 16px;
    line-height: 24px;
  }
`

export const ActionsRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 12px;
  .action-link:not(:first-child) {
    margin-left: 18px;
  }
`

export const ActionLink = styled.a`
  color: inherit;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  display: inline-flex;
  align-items: center;
  letter-spacing: 0.2px;

  i {
    margin-right: 8px;
    font-size: 14px;
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/ProductTemplates/InfoVariantCard/styledComponents.tsx